import React, { useState, useEffect, useContext, useRef } from 'react'
import { Button, Comment, Form, Transition, Icon, Divider, Message, Image } from 'semantic-ui-react';
import GlobalContext from '../../contexts/GlobalContext';
import Utility from '../../Utility';
import API, { ResponseManagement, ErrorManagement } from '../../API';
import MomentCustomer from './../MomentCustomer/MomentCustomer';
import Moment from 'moment';
import iconUser from './../../assets/matt.jpg';
import { toast } from 'react-toastify';
import './CommentForm.css';

/**
 * @param {folderId, messages} props 
 */
function CommentForm(props) {

  const [globalContext, dispatch] = useContext(GlobalContext);// eslint-disable-line
  const [messages, setMessages] = useState([]);// eslint-disable-line
  const [addMessageLoader, setAddMessageLoader] = useState(false);
  const divChat = useRef(null);
  let timeout = null;

  useEffect(() => {
    let messageData = [
      { id: 0, author: 'hotel', bookingFolderId: props.folderId, date: '', status: 'read', message: globalContext.translations.welcomeMessage }
    ];

    if (props.messages && props.messages.length > 0) {
      props.messages.forEach(message => {
        messageData.push(message);
      })
    }

    messageData.reverse();
    setMessages(messageData);

    return () => {
      if (timeout !== null) {
        clearTimeout(timeout);
      }
    }

  }, [globalContext.translations.welcomeMessage, props.messages])// eslint-disable-line react-hooks/exhaustive-deps


  const getDateMsg = (date) => {
    const dateMsg = Moment(date);
    const dateToday = Moment();
    const dateYesteday = Moment();
    dateYesteday.subtract(1, 'd');
    let labelDate;

    if(dateMsg._isValid === true) {
      if(dateMsg.format('YYYY-MM-DD') === dateToday.format('YYYY-MM-DD')) {
        labelDate = (
          <div>
            {globalContext.translations.today}
            &nbsp;
            {globalContext.translations.at}
            &nbsp;
            <MomentCustomer format="HH:mm:ss">{dateMsg}</MomentCustomer>
          </div>
        );
      } else if (dateMsg.format('YYYY-MM-DD') === dateYesteday.format('YYYY-MM-DD')) {
        labelDate = (
          <div>
            {globalContext.translations.yesteday}
            &nbsp;
            {globalContext.translations.at}
            &nbsp;
            <MomentCustomer format="HH:mm:ss">{dateMsg}</MomentCustomer>
          </div>
        );
      } else {
        labelDate = globalContext.translations.daysAgo.replace('{{nbJours}}', dateToday.diff(dateMsg, 'days'));
      }
      return (
        <Comment.Metadata>
          {labelDate}
        </Comment.Metadata>
      )
    } else {
      return null;
    }
  }

  const getContent = () => {
    const msg = props.mini && messages.length > 3 ? messages.slice(0, 3) : messages;
    //tri des message dans l'ordre croissant
    msg.sort(function (a, b) {
      if(a.date < b.date) { return -1; }
      if(a.date > b.date) { return 1; }
      return 0;
    });
    
    const messagesTab = msg.map(message => {
      const dataAuthorMsg = {
        logo: globalContext.establishment.logo,
        author: globalContext.establishment.lastName,
      }
      if(message.author === "user") {
        dataAuthorMsg.logo = iconUser;
        dataAuthorMsg.author = globalContext.translations.my;
      }

      return (
        <Comment key={message.id} className={`customComment ${message.author}`}>
          <Image rounded size="mini" className={`customAvatar ${message.author}`} as="a" src={Utility.imageExists(dataAuthorMsg.logo, 'logo')} />
          <Message floating className={`chatMessage ${message.author}`} >
            <Comment.Text>
              <p>
                {message.message}
              </p>
            </Comment.Text>
            <Comment.Metadata style={{margin:0}}>
              {getDateMsg(message.date)}
            </Comment.Metadata>
          </Message>
        </Comment>
      );
    })

    return messagesTab;
  }

  /**
   * Envoi message
   */
  const handleClick = () => {
    const message = props.mini ? document.querySelector('#message-comment-form-mini').value : document.querySelector('#message-comment-form').value;
    const btnSubmit = props.mini ? document.querySelector('#submit-comment-btn-mini') : document.querySelector('#submit-comment-btn');
    props.modal ? btnSubmit.classList.add('disabled', 'loading') : btnSubmit.classList.remove('disabled', 'loading');

    if (message !== '') {
      const newMessage = {
        bookingFolderId: props.folderId,
        message: {
          author: 'user',
          message: message.toString()
        }
      }

      setAddMessageLoader(true);

      API.postForm(Utility.getUrlAjax() + '/addMessage', newMessage)
        .then(response => {
          ResponseManagement(response,
            () => {
              const returnedMessage = response.data.data.messages;
              setMessages([returnedMessage[0], ...messages]);
              props.mini ? document.querySelector('#message-comment-form-mini').value = '' : document.querySelector('#message-comment-form').value = '';

              setAddMessageLoader(false);
            },
            () => {
              toast.error(globalContext.translations.msgErreurInconnu);
              setAddMessageLoader(false);
            }
          );
        })
        .catch(error => {
          ErrorManagement(error, () => { });
          setAddMessageLoader(false);
        });

      if (props.modal) {
        //setAlert(true);
        timeout = setTimeout(() => {
          props.modal(false);
        }, 1000)
      }
    }
  }

  const scrollBottomChat = () => {
    setTimeout(() => {
      if(divChat.current !== null){
        if(divChat.current.scrollTop !== null && divChat.current.scrollHeight !== null) {
          divChat.current.scrollTop = divChat.current.scrollHeight;
        }
      }
    }, 50);
  }

  const handleKeyPressEnter = (e) => {
    if(e.key === 'Enter') {
      handleClick();
    }
  }

  return (
    <div style={{ height: "100%" }}>
      {
        !props.mini &&
        <div>
          <h3 className="text-center mb-2">{globalContext.translations.comment}</h3>
          <Divider />
        </div>
      }
      {
        // alert
          // ? <div><h2 style={{ textAlign: "center" }}>Nous avons bien reçu votre remarque</h2></div>

          // : 
          <div id="scrollDiv" ref={divChat} style={{ height: props.height || 250, overflow: 'auto', padding: '2%', background: 'white', borderRadius: 3 }} >
            <Transition.Group
              style={{display:"flex",flexDirection:"column",maxWidth: 'initial'}}
              as={Comment.Group}
              duration={400}
              divided="true"
              size="small"
            /*  verticalalign="middle" */
            >
              {getContent()}
            </Transition.Group>
          </div>
      }
      <Form className="mt-3 extra" onSubmit={handleClick} reply >
        {props.mini
          ? <Form.Group unstackable>
            <Form.Field width={13}>
              <Form.Input spellCheck="false" id="message-comment-form-mini" name="message-comment-form-mini" onKeyPress={(e) => {handleKeyPressEnter(e)}} style={{resize: 'none'} } />
            </Form.Field>
            <Form.Field width={3} className="custom-align-right">
              <Button
                id="submit-comment-btn-mini"
                loading={addMessageLoader}
                disabled={addMessageLoader}
                type="submit"
                positive
                icon
              >
                <Icon name="send"/>
              </Button>
            </Form.Field>
          </Form.Group>

          : <div className="mt-3">
            <Form.TextArea
              style={{ background: 'whitesmoke' }}
              spellCheck="false"
              id="message-comment-form"
              name="message-comment-form"
              onKeyPress={(e) => {handleKeyPressEnter(e)}}
            />
              <div className="custom-align-right">
                <Button
                    id="submit-comment-btn"
                    loading={addMessageLoader}
                    disabled={addMessageLoader}
                    type="submit"
                    size="mini"
                    content={globalContext.translations.send}
                    labelPosition="left"
                    icon="send"
                    positive
                />
              </div>

          </div>
        }
      </Form>
      {scrollBottomChat()}
    </div>
  )
}

export default CommentForm